import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-white" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "max-w-md truncate text-sm text-blue-300" }
const _hoisted_7 = { class: "flex justify-end gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "text-white font-bold text-lg" }
const _hoisted_13 = { class: "flex flex-col items-end gap-2" }
const _hoisted_14 = { class: "flex items-center gap-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex items-center gap-2 bg-white/5 p-2 rounded justify-between" }
const _hoisted_18 = { class: "font-mono text-xs text-blue-300 truncate max-w-[250px]" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex items-center justify-between pt-2" }
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_25 = { class: "grid gap-6 py-4" }
const _hoisted_26 = { class: "grid gap-2" }
const _hoisted_27 = { class: "grid gap-2" }
const _hoisted_28 = { class: "grid gap-2" }
const _hoisted_29 = { class: "flex items-center gap-3" }
const _hoisted_30 = { class: "grid gap-2 col-span-full" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = {
  key: 0,
  class: "grid gap-2 col-span-full"
}
const _hoisted_33 = { class: "flex items-center gap-2" }

import { ref, onMounted, watch } from 'vue'
import {
  ArrowsUpDownIcon,
  LinkIcon,
  ClipboardIcon,
  // ExternalLinkIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { ArrowUpRight, CircleHelp } from 'lucide-vue-next'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { CreateButtonDTO, GetAllButtonsParams, useButton } from '@/composables/useButton'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { Button as IButton } from '@/interfaces/Button'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { useToast } from '@/components/ui/toast'
import { ButtonStatusEnum, ButtonStatusLabels } from '@/enums/buttons/ButtonStatusEnum'
import { Loader2 } from 'lucide-vue-next'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import StatusBadge from '@/components/ui/badge/StatusBadge.vue'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { ButtonPlacementEnum, ButtonPlacementLabels } from '@/enums/buttons/ButtonPlacementEnum'

// Table Configuration

export default /*@__PURE__*/_defineComponent({
  __name: 'ManageLinksView',
  setup(__props) {

const tableHeaders = [
  { key: 'name', label: 'Nome', sortable: false },
  { key: 'url', label: 'Link', sortable: false },
  { key: 'status', label: 'Status' },
  { key: 'actions', label: '', class: 'w-32' },
]

// Sample data (empty for demo)
const buttons = ref<IPagination<IButton>>()
const { getAll, create, update, destroy } = useButton()
const { toast } = useToast()

// Dialog and Form
const isSaving = ref(false)
const isButtonDialogOpen = ref(false)
const editingButton = ref<number | null>(null)
const deletingButton = ref<number | null>(null)
const isDeleteButtonDialogOpen = ref(false)
const isDeletingButton = ref(false)
const buttonForm = ref<Partial<CreateButtonDTO>>({})
const perPage = ref('10')

// Utils
const copyLink = async (url: string) => {
  await navigator.clipboard.writeText(url)
  // Add toast notification here
}

const openLink = (url: string) => {
  window.open(url, '_blank')
}

// Actions
const openNewLinkDialog = () => {
  editingButton.value = null
  buttonForm.value = { status: ButtonStatusEnum.ACTIVE, style: undefined }
  isButtonDialogOpen.value = true
}

const closeButtonDialog = () => {
  isButtonDialogOpen.value = false
}

const editButton = (button: IButton) => {
  editingButton.value = button.id
  buttonForm.value = {
    name: button.name,
    url: button.url,
    status: button.status,
    placement: button.placement,
    style: button.style
  }
  isButtonDialogOpen.value = true
}

const saveButton = () => {
  isSaving.value = true

  if (!editingButton.value) {
    create(buttonForm.value as CreateButtonDTO).then(() => {
      isSaving.value = false
      toast({
        title: 'Link criado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      getAll().then((data) => buttons.value = data)
      closeButtonDialog()
    }).catch(() => {
      isSaving.value = false
    })
  } else {
    update(editingButton.value, buttonForm.value).then(() => {
      isSaving.value = false
      toast({
        title: 'Link editado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      const index = buttons.value?.data.findIndex(button => button.id == editingButton.value)
      if (index !== -1 && index !== null && index !== undefined) {
        buttons.value!.data[index] = {
          ...buttons.value!.data[index],
          ...buttonForm.value
        }
      }
      closeButtonDialog()
    }).catch(() => {
      isSaving.value = false
    })
  }
}

const deleteLink = (button: IButton) => {
  isDeleteButtonDialogOpen.value = true
  deletingButton.value = button.id
}

const sortBy = (key: string) => {
  // Implement sorting logic
}

const reloadAndGetAll = (params: GetAllButtonsParams) => {
  buttons.value = undefined
  getAll(params).then((data) => buttons.value = data)
}

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

onMounted(() => {
  getAll().then((data) => buttons.value = data)
})

return (_ctx: any,_cache: any) => {
  const _component_ExternalLinkIcon = _resolveComponent("ExternalLinkIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" Gerencie seus links de redirecionamento ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" Administre e personalize seus links de redirecionamento com facilidade. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewLinkDialog }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("Cadastrar link")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
            _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Links registrados"),
            _createElementVNode("div", { class: "flex items-center gap-4" })
          ], -1)),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TableRow, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createVNode(TableHead, {
                          key: header.key,
                          class: _normalizeClass(header.class)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(header.label) + " ", 1),
                              (header.sortable)
                                ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                    key: 0,
                                    class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                    onClick: ($event: any) => (sortBy(header.key))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (buttons.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (buttons.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(LinkIcon),
                              title: "Nenhum botão encontrado",
                              description: `Clique em 'Cadastrar botão' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value.data, (button) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: button.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "p-2 px-8 rounded inline-flex py-2.5 px-3 text-center relative",
                                    style: _normalizeStyle({ 
                    backgroundColor: button.style === 'primary' ? '#2B6B84' : 
                                    button.style === 'success' ? '#377531' : 
                                    button.style === 'danger' ? '#A44236' : '#2c3b4b4f' 
                  })
                                  }, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(button.name), 1),
                                    _createVNode(_unref(ArrowUpRight), { class: "size-3 absolute right-1 top-1 text-white" })
                                  ], 4)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(button.url), 1),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "opacity-0 group-hover:opacity-100",
                                      onClick: ($event: any) => (copyLink(button.url))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ClipboardIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "opacity-0 group-hover:opacity-100",
                                      onClick: ($event: any) => (openLink(button.url))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ExternalLinkIcon, { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(StatusBadge, {
                                    status: button.status
                                  }, null, 8, ["status"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (editButton(button))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-red-400",
                                      onClick: ($event: any) => (deleteLink(button))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (buttons.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (buttons.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(buttons.value.data, (button) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: button.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Link", -1)),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", {
                                  class: "p-1 px-3 rounded inline-flex text-center relative",
                                  style: _normalizeStyle({ 
                        backgroundColor: button.style === 'primary' ? '#2B6B84' : 
                                        button.style === 'success' ? '#377531' : 
                                        button.style === 'danger' ? '#A44236' : '#2c3b4b4f' 
                      })
                                }, [
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(button.name), 1)
                                ], 4)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editButton(button)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "size-5" })
                              ], 8, _hoisted_15),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deleteLink(button)),
                                class: "text-zinc-400 hover:text-red-400 p-1"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "size-5" })
                              ], 8, _hoisted_16)
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createVNode(MobileDataLabel, { label: "URL" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(button.url), 1),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (copyLink(button.url)),
                                    class: "rounded-lg p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white"
                                  }, [
                                    _createVNode(_unref(ClipboardIcon), { class: "size-4 text-white" })
                                  ], 8, _hoisted_20),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (openLink(button.url)),
                                    class: "rounded-lg p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white"
                                  }, [
                                    _createVNode(_unref(ArrowUpRight), { class: "size-4 text-white" })
                                  ], 8, _hoisted_21)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Status", -1)),
                              _createVNode(StatusBadge, {
                                status: button.status
                              }, null, 8, ["status"])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_unref(LinkIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[18] || (_cache[18] = _createTextVNode(" Nenhum botão encontrado "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (buttons.value?.pagination)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 1,
                "onUpdate:page": _cache[0] || (_cache[0] = page => reloadAndGetAll({ page, perPage: perPage.value })),
                data: buttons.value?.pagination,
                "per-page": perPage.value,
                "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event))
              }, null, 8, ["data", "per-page"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteButtonDialogOpen.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isDeleteButtonDialogOpen).value = $event)),
      loading: isDeletingButton.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => {isDeletingButton.value = true; _unref(destroy)(deletingButton.value!).then(() => {
    _unref(toast)({
      title: 'Link excluído com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isDeletingButton.value = false
    isDeleteButtonDialogOpen.value = false
    const index = buttons.value?.data.findIndex(button => button.id == deletingButton.value)
    if (index !== -1) buttons.value?.data.splice(index!, 1)
  })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isButtonDialogOpen.value,
      "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((isButtonDialogOpen).value = $event)),
      onClose: closeButtonDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "sm:max-w-xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingButton.value ? 'Editar link' : 'Novo link'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode(" Configure as informações do link de redirecionamento. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Nome do botão "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: buttonForm.value.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((buttonForm.value.name) = $event)),
                  placeholder: "Ex: Nosso site"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("URL de redirecionamento "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: buttonForm.value.url,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((buttonForm.value.url) = $event)),
                  placeholder: "https://exemplo.com"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Cor do botão")
                  ])),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (buttonForm.value.style = undefined)),
                    class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [buttonForm.value.style === undefined || buttonForm.value.style === '' ? 'border-white scale-110' : 'border-transparent']]),
                    style: {"background-color":"#2c3b4b4f"},
                    title: "Padrão (Cinza)"
                  }, null, 2),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (buttonForm.value.style = 'primary')),
                    class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [buttonForm.value.style === 'primary' ? 'border-white scale-110' : 'border-transparent']]),
                    style: {"background-color":"#2B6B84"},
                    title: "Azul"
                  }, null, 2),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (buttonForm.value.style = 'success')),
                    class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [buttonForm.value.style === 'success' ? 'border-white scale-110' : 'border-transparent']]),
                    style: {"background-color":"#377531"},
                    title: "Verde"
                  }, null, 2),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (buttonForm.value.style = 'danger')),
                    class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [buttonForm.value.style === 'danger' ? 'border-white scale-110' : 'border-transparent']]),
                    style: {"background-color":"#A44236"},
                    title: "Vermelho"
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_unref(Label), null, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("Status "),
                      _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(TooltipProvider), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(TooltipContent), {
                            side: "top",
                            "side-offset": 5
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Status oculto: Este botão não será exibido "),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" quando o usuário iniciar o bot. ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(Select), {
                  modelValue: buttonForm.value.status,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((buttonForm.value.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectTrigger), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectValue), { placeholder: "Selecione o status" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(SelectContent), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ButtonStatusEnum), (status) => {
                          return (_openBlock(), _createBlock(_unref(SelectItem), { value: status }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(ButtonStatusLabels)[status]), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 256))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (buttonForm.value.status === _unref(ButtonStatusEnum).ACTIVE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_unref(Label), null, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode("Posição "),
                          _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _createVNode(_unref(Select), {
                      modelValue: buttonForm.value.placement,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((buttonForm.value.placement) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectTrigger), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectValue), { placeholder: "Selecione a posição" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(SelectContent), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ButtonPlacementEnum), (status) => {
                              return (_openBlock(), _createBlock(_unref(SelectItem), { value: status }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(ButtonPlacementLabels)[status]), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 256))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "text-white",
                  variant: "ghost",
                  onClick: closeButtonDialog
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isSaving.value || (!buttonForm.value.name || !buttonForm.value.url),
                  onClick: saveButton
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(editingButton.value ? 'Salvar alterações' : 'Cadastrar link'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})